import { useEffect, useState } from 'react'
import Layout from '../../../components/common/pageLayout'
import Form from '../../../components/SiteManagement/Print/ShipyardEvaluationPerformance/index'
import { toast } from 'react-toastify';
import {
    v2_projects,
} from '../../../actions/v2/projectAndVessel';

import { v2_ship_owners, v2_shipyards } from '../../../actions/v2/masterData';
import { v3_fetchShipyardEvaluationPerformaceFormFields } from '../../../actions/v3/siteManagement';

const NewBuildingBlockInspectionStatus = (props) => {
    const { data } = props;

    const [state, setState] = useState({
        cooperation_with_owners_team: { name: 'cooperation_with_owners_team', value: '', error: '', isRequired: true },
        response_to_additional_work_query: { name: 'response_to_additional_work_query', value: '', error: '', isRequired: true },
        quality_policy_practice: { name: 'quality_policy_practice', value: '', error: '', isRequired: true },
        hse_policy_practise: { name: 'hse_policy_practise', value: '', error: '', isRequired: true },
        quality_of_design_team: { name: 'quality_of_design_team', value: '', error: '', isRequired: false },
        on_time_delivery: { name: 'on_time_delivery', value: '', error: '', isRequired: false },
        after_sales_service: { name: 'after_sales_service', value: '', error: '', isRequired: false },
        overall_performance_of_yard: { name: 'overall_performance_of_yard', value: '', error: '', isRequired: true },
        grade: { name: 'grade', value: '', error: '', isRequired: true },

    });


    const [commonDetails, setCommonDetails] = useState({
        shipyard: { value: '', options: [], error: '' },
        shipowner: { value: '', options: [], error: '' },
        builtDuration: { value: '' },
        project: { value: '', options: [] },
        noOfShipBuilt: { value: '', options: [], },
        dateOfReport: { value: '', options: [] },
        finalSubmit: { value: false }
    });

    const [showLoader, setShowLoader] = useState(false);

    // Load projects
    useEffect(() => {
        v2_ship_owners().then((res) => {
            if (res.status) {
                setCommonDetails((prev) => ({
                    ...prev,
                    shipowner: { ...prev.shipowner, options: res.result },
                }));
            }
        });
        v2_shipyards().then((res) => {
            if (res.status) {
                setCommonDetails((prev) => ({
                    ...prev,
                    shipyard: { ...prev.shipyard, options: res.result },
                }));
            }
        })
        v2_projects().then((res) => {
            if (res.status) {
                setCommonDetails((prev) => ({
                    ...prev,
                    project: { ...prev.project, options: res.result },
                }));
            }
        })
    }, []);



    useEffect(() => {
        const params = data

        if (params) {
            setShowLoader(true);
            v3_fetchShipyardEvaluationPerformaceFormFields(params.FORM_ID)
                .then((res) => {
                    if (res.status) {
                        const { records } = res.result;
                        // Set common details
                        if (params.FORM_ID) {
                            setCommonDetails((prev) => ({
                                ...prev,
                                shipyard: { ...prev.shipyard, value: res.result.commonDetails?.SHIPYARD_ID || '' },
                                shipowner: { ...prev.shipowner, value: res.result.commonDetails?.SHIP_OWNER_ID || '' },
                                dateOfReport: { ...prev.dateOfReport, value: res.result.commonDetails?.SUBMISSION_DATE || '' },
                                noOfShipBuilt: { ...prev.dateOfReport, value: res.result.commonDetails?.NUMBER_OF_SHIPS_BUILT },
                                project: { ...prev.project, value: res.result.commonDetails?.PROJECT_ID || '' },
                                builtDuration: { ...prev.builtDuration, value: res.result.commonDetails?.BUILD_DURATION_DAYS || '' },
                                finalSubmit: { ...prev.finalSubmit, value: Boolean(res.result.commonDetails?.FINAL_SUBMITTED) || '' },
                            }));


                            setState((prev) => ({
                                ...prev,
                                cooperation_with_owners_team: { ...prev.cooperation_with_owners_team, value: records?.COOPERATION_WITH_OWNERS_TEAM || '' },
                                response_to_additional_work_query: { ...prev.response_to_additional_work_query, value: records?.RESPONSE_TO_ADDITIONAL_WORK_REQ || '' },
                                quality_policy_practice: { ...prev.quality_policy_practice, value: records?.QUALITY_POLICY_PRACTICE || '' },
                                hse_policy_practise: { ...prev.hse_policy_practise, value: records?.HSE_POLICY_PRACTICE || '' },
                                quality_of_design_team: { ...prev.quality_of_design_team, value: records?.QUALITY_OF_DESIGN_TEAM || '' },
                                on_time_delivery: { ...prev.on_time_delivery, value: records?.ON_TIME_DELIVERY || '' },
                                after_sales_service: {
                                    ...prev.after_sales_service,
                                    value: records?.AFTER_SALES_SERVICE || ''
                                },

                                overall_performance_of_yard: {
                                    ...prev.overall_performance_of_yard,
                                    value: records?.OVERALL_PERFORMANCE_OF_YARD || ''
                                },

                                grade: {
                                    ...prev.grade,
                                    value: records?.GRADE || ''
                                },
                            }));

                        }

                    } else {
                        toast.error(res.error || 'Error fetching NCR form data');
                    }
                })
                .catch(() => {
                    toast.error('Something went wrong while fetching.');
                })
                .finally(() => {
                    setShowLoader(false);
                });
        }
    }, []);


    return (
        <div className="row">
            <div className="col-lg-12">
                <div className="card" id={1}>
                    <div className="card-body">
                        <div className="checklist-title-bx">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="text-center">
                                        <h4>SHIPYARD EVALUATION OF SHIPYARD PERFORMANCE
                                        </h4>

                                    </div>
                                </div>
                            </div>
                        </div>


                        <div className="row">
                            <div className="col-md-12 ">
                                <div className="report-index-top">
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td className="hd-s2">
                                                    <p>Name of Shipyard</p>
                                                </td>
                                                <td className="td-input-bx">
                                                    <div className="hull-select-box">
                                                        <select
                                                            className="form-select"
                                                            value={commonDetails.shipyard.value}
                                                            disabled={data ? true : false}
                                                            onChange={(e) =>
                                                                setCommonDetails((prev) => ({
                                                                    ...prev,
                                                                    shipyard: { ...prev.shipyard, value: e.target.value },
                                                                }))
                                                            }
                                                        >

                                                            <option value={''}>Select Shipyard</option>
                                                            {commonDetails.shipyard.options.map((item) => {
                                                                return (<option value={item.ID}>{item.SHIPYARD_NAME}</option>)
                                                            })}
                                                        </select>
                                                    </div>
                                                </td>

                                                <td className="hd-s2 pl10">
                                                    <p>Ship Owner</p>
                                                </td>
                                                <td className="td-input-bx">
                                                    <select
                                                        className="form-select"
                                                        value={commonDetails.shipowner.value}
                                                        disabled={data ? true : false}
                                                        onChange={(e) =>
                                                            setCommonDetails((prev) => ({
                                                                ...prev,
                                                                shipowner: { ...prev.shipowner, value: e.target.value },
                                                            }))
                                                        }
                                                    >

                                                        <option value={''}>Select Owner</option>
                                                        {commonDetails.shipowner.options.map((item) => {
                                                            return (<option value={item.ID}>{item.OWNER_NAME}</option>)
                                                        })}
                                                    </select>
                                                </td>
                                                <td className="hd-s2">
                                                    <p>Build Duration</p>
                                                </td>
                                                <td className="td-input-bx">
                                                    <input
                                                        type="number"
                                                        className="form-control"
                                                        placeholder={`Duration in Day's`}
                                                        value={commonDetails.builtDuration.value}
                                                        onChange={(e) =>
                                                            setCommonDetails((prev) => ({
                                                                ...prev,
                                                                builtDuration: { ...prev.builtDuration, value: e.target.value },
                                                            }))
                                                        }
                                                    />
                                                </td>
                                            </tr>
                                            <tr>

                                                <td className="hd-s2 pl10 w150">
                                                    <p>Project</p>
                                                </td>
                                                <td className="td-input-bx">
                                                    <select
                                                        className="form-select"
                                                        disabled={data ? true : false}
                                                        value={commonDetails.project.value}
                                                        onChange={(e) => {
                                                            setCommonDetails((prev) => ({
                                                                ...prev,
                                                                project: { ...prev.project, value: e.target.value }
                                                            }));
                                                        }}


                                                    >

                                                        <option value={''}>Select Project</option>
                                                        {commonDetails.project.options.map((item) => {
                                                            return (<option value={item.ID}>{item.PROJECT_NAME}</option>)
                                                        })}
                                                    </select>
                                                </td>
                                                <td className="hd-s2 pl10">
                                                    <p>No of Ships built</p>
                                                </td>
                                                <td className="td-input-bx">
                                                    <input
                                                        type="number"
                                                        className="form-control"
                                                        placeholder="No of Ships built"

                                                        value={commonDetails.noOfShipBuilt.value}
                                                        onChange={(e) =>
                                                            setCommonDetails((prev) => ({
                                                                ...prev,
                                                                noOfShipBuilt: { ...prev.noOfShipBuilt, value: e.target.value },
                                                            }))
                                                        }
                                                    />
                                                </td>


                                                <td className="hd-s2 pl10">
                                                    <p>Date of Report</p>
                                                </td>
                                                <td className="td-input-bx">
                                                    <input
                                                        type="date"
                                                        className="form-control"
                                                        value={commonDetails.dateOfReport.value}
                                                        name={commonDetails.dateOfReport.name}
                                                        onChange={(e) =>
                                                            setCommonDetails((prev) => ({
                                                                ...prev,
                                                                dateOfReport: { ...prev.dateOfReport, value: e.target.value },
                                                            }))
                                                        }
                                                    />
                                                </td>

                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div className="note-info">
                                    <p>Enter date of issue/ Reference No/ Suject as above in NCR Index</p>
                                </div>
                            </div>
                        </div>

                        <Form
                            onChange={console.log('not allowed')}
                            state={state}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default NewBuildingBlockInspectionStatus